import '../../assets/index15.css';var x = Object.defineProperty, C = Object.defineProperties;
var f = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var _ = Object.prototype.hasOwnProperty, m = Object.prototype.propertyIsEnumerable;
var l = (o, e, t) => e in o ? x(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t, b = (o, e) => {
  for (var t in e || (e = {}))
    _.call(e, t) && l(o, t, e[t]);
  if (a)
    for (var t of a(e))
      m.call(e, t) && l(o, t, e[t]);
  return o;
}, d = (o, e) => C(o, f(e));
var p = (o, e) => {
  var t = {};
  for (var r in o)
    _.call(o, r) && e.indexOf(r) < 0 && (t[r] = o[r]);
  if (o != null && a)
    for (var r of a(o))
      e.indexOf(r) < 0 && m.call(o, r) && (t[r] = o[r]);
  return t;
};
import { jsxs as y, jsx as n } from "react/jsx-runtime";
import { forwardRef as F } from "react";
import { ErrorMessage as I } from "../../molecules/ErrorMessage/index.js";
import { Label as N } from "../Label/index.js";
import { C as v, G as w } from "../../index-CYRBNvUr.js";
import { CheckFarFAIcon as g } from "../Icons/index.js";
const j = "Checkbox-module__container___FFDwI", A = "Checkbox-module__root___0NvcV", E = "Checkbox-module__body___iat8w", G = "Checkbox-module__input___FPIR1", R = "Checkbox-module__label___kt2po", c = {
  container: j,
  root: A,
  body: E,
  input: G,
  label: R
}, B = ({ className: o }) => /* @__PURE__ */ n(g, { className: o }), h = F((L, k) => {
  var s = L, {
    error: o,
    mod: e,
    label: t,
    required: r,
    className: D
  } = s, u = p(s, [
    "error",
    "mod",
    "label",
    "required",
    "className"
  ]);
  const i = !!o || void 0;
  return /* @__PURE__ */ y("div", { className: c.container, children: [
    /* @__PURE__ */ n(
      v,
      d(b({}, u), {
        "aria-invalid": i,
        classNames: {
          root: c.root,
          body: c.body,
          input: c.input,
          label: c.label
        },
        mod: { error: i },
        ref: k,
        label: /* @__PURE__ */ n(N, { label: String(t), withAsterisk: r }),
        icon: B
      })
    ),
    o && /* @__PURE__ */ n(I, { error: o })
  ] });
});
h.displayName = "Checkbox";
const z = Object.assign(h, { Group: w });
export {
  z as Checkbox,
  h as Item
};
